export default "__VITE_ASSET__DGuVOQrB__"